import {Nullish} from 'shared/web';

export type CampaignData = {
  platformCode: string;
  serviceCode: string;
  serviceCampaignId: string;
  name: string | Nullish;
};
